import { Currency, ValidatedFormatNumberOptions } from './types';
import { useMelioIntl } from './useMelioIntl';

type FormattedCurrencyProps = { amount: number; currency?: Currency; options?: ValidatedFormatNumberOptions };

export const FormattedCurrency = ({ amount, currency = 'USD', options }: FormattedCurrencyProps) => (
  <>{useMelioIntl().formatCurrency(amount, currency, options)}</>
);
